import React from 'react';
import Tabs from 'components/utilities/tabs/Tabs';

// Import helrpes
import { basicEpgTabs } from './helpers';

const EPGTabs = () => <Tabs tabs={basicEpgTabs} />;

export default EPGTabs;
